module Tapas.ViewModels {
    export class QuickOrderRow {
        stocknr = ko.observable("");
        amount = ko.observable(1);
        comment = ko.observable("");
        name = ko.observable("");
        Id = ko.observable("");
        VariantId = ko.observable("");
    }
    export class QuickOrderExcelViewModel extends Tapas.ViewModels.CartViewModel {
        public Quickorders = ko.observableArray<QuickOrderRow>();
        public QuickOrderHelpVisible = ko.observable(false);
        public QuickOrderInput = ko.observable("");
        public QuickOrderExcelInputDisabled = ko.observable(false);
        public QuickOrderInputDisabled = ko.observable(false);
        public QuickOrderInstantSearchPageId = ko.observable();
        public Loader = "<img src='/Files/Templates/Designs/Tapas/assets/img/loading.gif' />";
        public NoProductText = ko.observable("");
        public ResetQuickOrderLines;
        public SweetAlertVisible = ko.observable(false);

        public SetSweetAlert() {
            if (this.SweetAlertVisible()) {
                this.SweetAlertType('');
                this.SweetAlertVisible(false);
            } else {
                this.SweetAlertVisible(true);
                this.SweetAlertType('confirmation');
            }
        }

        public SweetAlertType = ko.observable('');
        public CheckInput = () => {
            var input = this.QuickOrderInput();
            var rows = input.toString().split(/\n/);
            ko.utils.arrayForEach(rows, (row: string) => {
                if (row != "") {
                    var quickOrderRow = new QuickOrderRow();

                    var item = row.split(/\t|;|,|:/);
                    if (item.length > 2) {
                        quickOrderRow.stocknr(item[0]);
                        quickOrderRow.amount(parseInt(item[1]));
                        quickOrderRow.comment(item[2]);
                        quickOrderRow.name(this.Loader);

                        var match = ko.utils.arrayFirst(this.Quickorders(), (item: QuickOrderRow) => {
                            return item.stocknr() === quickOrderRow.stocknr() && item.comment() === quickOrderRow.comment() && item.amount() === quickOrderRow.amount();
                        });

                        if (!match) {
                            this.Quickorders.push(quickOrderRow);
                        }
                    }
                }
            });

            this.SearchQuery();
        };
        public GetProductsById;
        public RemoveQuickOrderLine;
        public AddEmptyQuickOrderLine = () => {
            this.Quickorders.push(new QuickOrderRow());


        };
        public AddAmount;
        public RemoveAmount;
        public fadeBeforeRemove;
        public fadeIn;
        public SearchQuery = () => {
            this.QuickOrderInput("");
            var prodArray = new Array<string>();
            ko.utils.arrayForEach(this.Quickorders(), (order: QuickOrderRow) => {
                prodArray.push(order.stocknr());
            });

            var link = "/Default.aspx?ID=" + this.QuickOrderInstantSearchPageId() + "&ProductNumbers=" + prodArray.join(",") + "&View=eCom/Productlist/jsonProductOutput.cshtml&pagesize=1000";

            var orders = this.Quickorders();
            if (orders.length > 0) {
                this.data.get(link).then((data) => {
                    ko.utils.arrayForEach(orders, (item: QuickOrderRow) => {
                       
                            item.name(this.NoProductText());
                        

                        ko.utils.arrayForEach(data, (dataitem: any) => {
                           

                            if (item.stocknr() === dataitem.productNumber) {
                                item.name(dataitem.productName);
                                item.Id(dataitem.productId);
                                item.VariantId(dataitem.productVariantId);

                            }
                      


                        });
                    });



                }).catch((error) => {

                });
            }
        };
        public AddAllToCart() {
            var all = this.Quickorders();
            if (all.length < 1) return;
            this.CartLoading(true);

            var addToCartArgs = new Array<Ftw.Dataservice.ICartAddArgs>();

            $.each(all, ((i, row: QuickOrderRow) => {
                if (row.name() !== this.NoProductText()) {
                    var orderLineFields = new Array<Ftw.Dataservice.ICartAddOrderLineField>();
                    var orderLineField = <Ftw.Dataservice.ICartAddOrderLineField>{
                        systemName: 'Comment',
                        value: row.comment()
                    };
                    orderLineFields.push(orderLineField);
                    var addToCartObj = <Ftw.Dataservice.ICartAddArgs>{
                        productId: row.Id(),
                        quantity: row.amount(),
                        orderLineFields: orderLineFields,
                        variantId: row.VariantId(),
                    };
                    addToCartArgs.push(addToCartObj);
                }
            }));

            this.CartDataService.AddMultipleProducts(addToCartArgs).then((result) => {

            }).finally(() => {
                this.CartLoading(false);
            });
        }
        constructor() {
            super();



            this.ResetQuickOrderLines = () => {
                this.QuickOrderInput("");
                this.Quickorders.removeAll();

                this.SweetAlertVisible(false);
            }

            this.fadeBeforeRemove = (element, index) => {

                $(element).fadeOut(function () {
                    $(element).remove();
                });

            };


            this.fadeIn = (element) => {
                $(element).hide().fadeIn();
            };

            this.QuickOrderInput.subscribe(() => {
                this.CheckInput();
            });



            this.RemoveQuickOrderLine = (data: QuickOrderRow) => {
                this.Quickorders.remove(data);

            };

            this.AddAmount = (data: QuickOrderRow) => {
                data.amount(data.amount() + 1);

            };
            this.RemoveAmount = (data: QuickOrderRow) => {
                data.amount(data.amount() - 1);

            };

            this.GetProductsById = () => {

                var productStringArray = new Array<string>();
                ko.utils.arrayForEach(this.Quickorders(), (item: QuickOrderRow) => {
                    productStringArray.push(item.stocknr().toString());
                });

                this.SearchQuery();
            };





        }
    }
}